import { render, staticRenderFns } from "./skeleton.vue?vue&type=template&id=91d5a0b8&scoped=true&"
var script = {}
import style0 from "./skeleton.vue?vue&type=style&index=0&id=91d5a0b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d5a0b8",
  null
  
)

export default component.exports